import React, { useEffect, useState } from "react";
import { useMoralis } from 'react-moralis';
import coverImagePlaceHolder from '../../../assets/cover-image-placeholder.jpeg'
import { useWeb3React } from '@web3-react/core';
import { toast } from 'react-toastify'
import { DateTime } from "luxon";
import axios from "axios";
import Select from 'react-select'
import MarketPlaceList from "../../components/collections/MarketPlaceList";

const customStyles = {
  option: (base, state) => ({
    ...base,
    background: "#212428",
    color: "#fff",
    borderRadius: state.isFocused ? "0" : 0,
    "&:hover": {
      background: "#16181b",
    }
  }),
  menu: base => ({
    ...base,
    background: "#212428 !important",
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0
  }),
  control: (base, state) => ({
    ...base,
    padding: 2
  })
};


const EditCollection = () => {

  const { Moralis, isInitialized } = useMoralis()
  const { account } = useWeb3React()

  const [coverImage, setCoverImage] = useState(null)
  const [isCoverImageUpdating, setIsCoverImageUpdating] = useState(false)
  const [coverImageCID, setCoverImageCID] = useState('')
  const [coverImageUrl, setCoverImageUrl] = useState(null)
  const [collectionName, setCollectionName] = useState('')
  const [isCollectionCreatingLoading, setIsCollectionCreatingLoading] = useState(false)

  const [searchTerm, setSearchTerm] = useState('')
  const [nftCategory, setNftCategory] = useState('-1')
  const [onSaleItems, setOnSaleItems] = useState([])

  const [selectedNFTList, setSelectedNFTList] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)

  const options = [
    { value: '-1', label: 'All categories' },
    { value: '1', label: 'Uncategorized' },
    { value: '2', label: 'Art' },
    { value: '3', label: 'Music' },
    { value: '4', label: 'Cartoon' },
    { value: '5', label: 'Collectibles' },
  ]


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const adminAddressLowerCase = []
    const adminAddress = process.env.REACT_APP_ADMIN_ADRS.split(',')

    if (adminAddress && adminAddress.length > 0) {
      adminAddress.forEach(address => {
        adminAddressLowerCase.push(address.toLowerCase())
      })
    }

    if (account) {
      const currentUserAddress = account.toLowerCase()
      const result = adminAddressLowerCase.includes(currentUserAddress)
      if (result) {
        setIsAdmin(true)
      } else {
        setIsAdmin(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized && account) {

      if (isAdmin) {
        try {
          setIsLoading(true)
          const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
          const query = new Moralis.Query(CreatedMarketplaceItems)
          query.equalTo('sold', false)
          const result = await query.find()
          setOnSaleItems(result)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          console.error('MORALIS ERROR : error while fetching marketplace data', error)
        }
      } else {
        try {
          setIsLoading(true)
          const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
          const query = new Moralis.Query(CreatedMarketplaceItems)
          query.equalTo('sold', false)
          query.equalTo('seller', account.toLowerCase())
          const result = await query.find()
          setOnSaleItems(result)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          console.error('MORALIS ERROR : error while fetching marketplace data', error)
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, account, isAdmin])

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm !== '') {
        if (isInitialized && account) {

          if (isAdmin) {
            try {
              setIsLoading(true)
              const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
              const query = new Moralis.Query(CreatedMarketplaceItems)
              query.fullText('nftName', searchTerm)
              query.fullText('nftDescription', searchTerm)
              query.equalTo('sold', false)
              const result = await query.find()
              setOnSaleItems(result)
              setIsLoading(false)
            } catch (error) {
              setIsLoading(false)
              console.error('MORALIS ERROR : error while searching marketplace data', error)
            }
          } else {
            try {
              setIsLoading(true)
              const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
              const query = new Moralis.Query(CreatedMarketplaceItems)
              query.fullText('nftName', searchTerm)
              query.fullText('nftDescription', searchTerm)
              query.equalTo('sold', false)
              query.equalTo('seller', account.toLowerCase())
              const result = await query.find()
              setOnSaleItems(result)
              setIsLoading(false)
            } catch (error) {
              setIsLoading(false)
              console.error('MORALIS ERROR : error while searching marketplace data', error)
            }
          }


        }
      } else {

        if (isAdmin) {
          setIsLoading(true)
          const query = new Moralis.Query("MarketplaceItems")
          query.equalTo('sold', false)
          const result = await query.find()
          setOnSaleItems(result)
          setIsLoading(false)
        } else {
          setIsLoading(true)
          const query = new Moralis.Query("MarketplaceItems")
          query.equalTo('sold', false)
          query.equalTo('seller', account.toLowerCase())
          const result = await query.find()
          setOnSaleItems(result)
          setIsLoading(false)
        }

      }
    }, 400)

    return () => clearTimeout(delayDebounceFn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, account, isAdmin])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized && account) {

      if (isAdmin) {
        try {
          setIsLoading(true)
          const query = new Moralis.Query("MarketplaceItems")
          query.equalTo('sold', false)
          if (nftCategory !== "-1") {
            query.equalTo('categoryId', nftCategory)
          }
          const result = await query.find()
          setOnSaleItems(result)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          console.error('MORALIS ERROR : error while fetching marketplace data', error)
        }
      } else {
        try {
          setIsLoading(true)
          const query = new Moralis.Query("MarketplaceItems")
          query.equalTo('sold', false)
          query.equalTo('seller', account.toLowerCase())
          if (nftCategory !== "-1") {
            query.equalTo('categoryId', nftCategory)
          }
          const result = await query.find()
          setOnSaleItems(result)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          console.error('MORALIS ERROR : error while fetching marketplace data', error)
        }
      }

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, nftCategory, isAdmin])

  const nftSearchHandle = async (e) => {
    const userInput = e.target.value
    if (userInput) {
      setSearchTerm(userInput)
    } else {
      setSearchTerm('')
    }

  }

  const handleCategorySelect = (selectedCategory) => {
    setNftCategory(selectedCategory.value)
  }

  const uploadFileToIPFS = async (file) => {
    const endpoint = 'https://api.pinata.cloud/pinning/pinFileToIPFS'
    const pinataAPIKey = process.env.REACT_APP_PINATA_API_KEY
    const pinataAPISecret = process.env.REACT_APP_PINATA_SECRET_KEY

    const dt = DateTime.now()
    const newFileName = dt.toMillis() + "_" + file.name
    let data = new FormData();
    data.append('file', file);

    const metadata = JSON.stringify({
      name: newFileName,
      keyvalues: {
        h4gProfiles: 'marketplace-collection-cover' + newFileName
      }
    });
    data.append('pinataMetadata', metadata);

    const response = await axios.post(endpoint, data, {
      maxBodyLength: 'Infinity', //this is needed to prevent axios from erroring out with large files
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
        pinata_api_key: pinataAPIKey,
        pinata_secret_api_key: pinataAPISecret
      }
    })

    if (response.status === 200) {
      return response.data.IpfsHash
    } else {
      return null
    }
  }

  const handleCollectionCreate = async () => {

    if (!collectionName || collectionName === '') {
      toast.dark('Please enter the collection name', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }

    if (!coverImageCID || coverImageCID === '') {
      toast.dark('Please upload the cover image', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    if (!selectedNFTList || !selectedNFTList.length > 0) {
      toast.dark('Please select at least one NFT for your collection', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }


    if (isInitialized) {
      try {
        setIsCollectionCreatingLoading(true)
        const Collections = Moralis.Object.extend("Collections");
        const collection = new Collections();
        collection.set("createdBy", account)
        collection.set("coverImageCID", coverImageCID)
        collection.set("name", collectionName)
        collection.set("description", '')
        collection.set("status", 'active')
        collection.set("selectedNFT", JSON.stringify(selectedNFTList))
        await collection.save()
        setIsCollectionCreatingLoading(false)

        toast.dark('Collection has been updated', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        //reset the form
        setCoverImageUrl(null)
        setCollectionName('')
        setSelectedNFTList([])
      } catch (error) {
        setIsCollectionCreatingLoading(false)
        console.error('MORALIS ERROR : error while crating collection data', error)
      }
    }

  }

  const onImageChange = async (e) => {
    try {
      setIsCoverImageUpdating(true)
      const fileData = e.target.files[0]
      const ipfsHash = await uploadFileToIPFS(fileData)
      setCoverImageCID(ipfsHash)
      setCoverImage(fileData)
      setIsCoverImageUpdating(false)

    } catch (error) {
      console.error('Error while uploading file profile image', error)
      setIsCoverImageUpdating(false)
    }

  };


  useEffect(() => {
    if (coverImage) {
      const coverImageURLData = URL.createObjectURL(coverImage)
      setCoverImageUrl(coverImageURLData)
    }

  }, [coverImage])

  return (
    <div>
      <section className='container-fulid' style={{ padding: '0px' }}>
        {/* cover image section */}
        <div className="row">
          <div className="col-sm-12">
            <div className="cover-image-section">
              {
                coverImageUrl ? (
                  <img src={coverImageUrl} className="img-fluid cover-image" alt="cover" />
                ) :
                  (
                    <img src={coverImagePlaceHolder} className="img-fluid cover-image" alt="cover" />
                  )
              }

            </div>
          </div>
        </div>


      </section>

      <section className='container no-bottom'>


        <div className='row'>
          <div className="col-md-12">
            <div className="d_profile de-flex">
              <div className="de-flex-col">
                <div className="profile_avatar">
                  <div className="profile_name">
                    <h4>
                      <div className="profile_edit">

                        {
                          isCoverImageUpdating ?
                            (
                              <div className="spinner-grow" role="status">
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) :
                            (
                              <div>
                                <label htmlFor="files" className="btn-main profile-image-upload-btn">
                                  Upload Cover
                                </label>
                                <input
                                  style={{ visibility: 'hidden' }}
                                  id="files"
                                  type="file"
                                  multiple
                                  onChange={onImageChange}
                                  accept="image/*"
                                />
                              </div>
                            )
                        }
                        {/* <button className="btn-main profile-image-upload-btn">
                                
                              </button> */}
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <h5>Collection name</h5>
            <input
              type="text"
              name="collectionName"
              id="collectionName"
              value={collectionName}
              onChange={(e) => setCollectionName(e.target.value)}
              className="form-control"
              placeholder="Enter collection name" />
          </div>
        </div>
      </section>
      {

        (true) ?
          (
            <section className='container'>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className="items_filter">
                    <form className="row form-dark" id="form_quick_search" name="form_quick_search">
                      <div className="col">
                        <input className="form-control" onChange={nftSearchHandle} id="name_1" name="name_1" placeholder="search item here..." type="text" /> <button id="btn-submit"><i className="fa fa-search bg-color-secondary"></i></button>
                        <div className="clearfix"></div>
                      </div>
                    </form>
                    <div className='dropdownSelect one'>
                      <Select
                        className='select1'
                        styles={customStyles}
                        menuContainerStyle={{ 'zIndex': 999 }}
                        defaultValue={options[0]}
                        onChange={handleCategorySelect}
                        options={options} />
                    </div>
                    {/* <div className='dropdownSelect two'><Select className='select1' styles={customStyles} defaultValue={options1[0]} options={options1} /></div>
                  <div className='dropdownSelect three'><Select className='select1' styles={customStyles} defaultValue={options2[0]} options={options2} /></div> */}
                  </div>
                </div>
              </div>

              {
                isLoading ?
                  (
                    <section className='container'>
                      <div className='row'>
                        <div className='col-sm-12 col-md-12 col-lg-12'>
                          <div className='loading-container'>
                            <div className="spinner-grow" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  ) : (
                    <div>
                      <MarketPlaceList data={onSaleItems} setSelectedNFTList={setSelectedNFTList} selectedNFTList={selectedNFTList} />

                      {
                        isCollectionCreatingLoading ?
                          (<section className='container'>
                            <div className='row'>
                              <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='loading-container'>
                                  <div className="spinner-grow" role="status">
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>) :
                          (<section className='container'>
                            <div className='row'>
                              <div className='col-sm-12 col-md-12 col-lg-12'>
                                <button id="submit" className="btn-main" onClick={handleCollectionCreate}>
                                  Create collection
                                </button>
                              </div>
                            </div>
                          </section>)
                      }

                    </div>

                  )


              }

            </section>
          )
          :
          (<section className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <div className="alert alert-danger" role="alert">
                  Invalid user address
                </div>
              </div>
            </div>
          </section>)
      }
    </div>
  );
}
export default EditCollection;